import apiClient from '../apiClient';
import { DELETE_SERVICE_PRICE_URL } from '../apiUrl';

const deleteServicePrice = id => {
  return apiClient.delete(DELETE_SERVICE_PRICE_URL(id));
};

export default deleteServicePrice;
